module.exports = "<div style=\"width: 100%;height: 100vh; overflow-y: hidden;\">\r\n  <iframe src=\"https://www.unifar.com.br/blog-unifar\" style=\"margin-top: -184px;width: 100%;height: 125vh\">\r\n  </iframe>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/app/area-cliente/portal/tela-noticias/tela-noticias.component.html
// module id = ../../../../../src/app/area-cliente/portal/tela-noticias/tela-noticias.component.html
// module chunks = 1